const icons = {
  txt: 'fa-file-alt',
  pdf: 'picture_as_pdf',
  zip: 'fa-file-archive',
  image: 'insert_photo',
  video: 'movie',
  audio: 'audiotrack',
  csv: 'fa-file-csv',
  default: 'attachment',
};

const iconFromExtension = (extension) => {
  switch (extension) {
    case 'txt':
      return icons.txt;
    case 'pdf':
      return icons.pdf;
    case 'zip' || 'rar' || '7z' || 'tar' || 'gz':
      return icons.zip;
    case 'jpg' || 'jpeg' || 'png' || 'gif' || 'webp':
      return icons.image;
    case 'mp4' || 'webm':
      return icons.video;
    case 'mp3' || 'ogg':
      return icons.audio;
    case 'csv':
      return iconFromExtension.csv;
    default:
      return icons.default;
  }
};

export const validImageExtensions = [
  'jpg',
  'jpeg',
  'png',
  'svg',
  'tiff',
  'gif',
];

export const imageMinSizeQuality = {
  width: 1,
  height: 1,
};

export default {
  iconFromExtension,
};
